const i18n = {
  'feedback': {
    'content': '訊息內容',
    'main': '遇到任何問題嗎？',
    'message': '我們已經收到您的訊息，我們會以電子郵件聯絡您來解決問題。',
  }
};
export default i18n;
